import React, { useState } from "react";
import { X } from "lucide-react";

const DisableUserModal = ({
  isOpen,
  onClose,
  onSubmit,
  title = "Disable User",
  description = "Are you sure you want to disable this user?",
  confirmLabel = "Disable user",
}) => {
  const [reason, setReason] = useState("");

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(reason);
    setReason("");
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 w-full">
      <div className="bg-white rounded-2xl p-6 w-full max-w-96 relative">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute right-4 top-4 text-gray-400 hover:text-gray-600"
        >
          <X size={20} />
        </button>

        {/* Modal content */}
        <div className="space-y-4">
          <form onSubmit={handleSubmit} className="flex flex-col">
            <div className="self-center flex flex-col items-center">
              <label className="block text-lg font-semibold text-[#EB5757] mb-2 font-sans">
                {title}
              </label>
              <p className="text-sm text-[#4F4F4F] self-center mb-2">
                {description}
              </p>
            </div>

            <button className="py-3 px-3 my-4 w-56 border bg-[#EB5757] text-white self-center rounded-full font-sans">
              {confirmLabel}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default DisableUserModal;
